// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var V4 = require("uuid/v4");
var Core__List = require("@rescript/core/src/Core__List.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function make(id, type_, text, time, renderButtons, dismissableOpt) {
  var dismissable = dismissableOpt !== undefined ? dismissableOpt : true;
  return {
          id: id !== undefined ? id : V4(),
          type_: type_,
          text: text,
          time: time,
          renderButtons: renderButtons,
          dismissable: dismissable
        };
}

var Message = {
  make: make
};

function defaultValue_addMessage(param) {
  
}

function defaultValue_removeMessage(param) {
  
}

var defaultValue = {
  addMessage: defaultValue_addMessage,
  removeMessage: defaultValue_removeMessage,
  messages: /* [] */0
};

var systemMessagesContext = React.createContext(defaultValue);

var make$1 = systemMessagesContext.Provider;

var Provider = {
  make: make$1
};

function SystemMessages$Provider(props) {
  var match = React.useState(function () {
        return /* [] */0;
      });
  var setMessages = match[1];
  var addMessage = React.useCallback((function (message) {
          setMessages(function (state) {
                return Core__List.add(state, message);
              });
        }), [setMessages]);
  var removeMessage = React.useCallback((function (id) {
          setMessages(function (state) {
                return Core__List.filter(state, (function (x) {
                              return x.id !== id;
                            }));
              });
        }), [setMessages]);
  var value_messages = match[0];
  var value = {
    addMessage: addMessage,
    removeMessage: removeMessage,
    messages: value_messages
  };
  return JsxRuntime.jsx(make$1, {
              value: value,
              children: props.children
            });
}

var Provider$1 = {
  Provider: Provider,
  make: SystemMessages$Provider
};

function useSystemMessages() {
  return React.useContext(systemMessagesContext);
}

var providerJs = SystemMessages$Provider;

exports.Message = Message;
exports.defaultValue = defaultValue;
exports.systemMessagesContext = systemMessagesContext;
exports.Provider = Provider$1;
exports.providerJs = providerJs;
exports.useSystemMessages = useSystemMessages;
/* systemMessagesContext Not a pure module */
